import { Result } from 'antd';
import { selectPermissionsInitLoaded } from 'app/containers/Authorization/slice/selectors';
import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

interface IProps {}

const NoPermissionsCard: FC<IProps> = () => {
  const { t } = useTranslation();
  const permissionsInitLoaded = useSelector(selectPermissionsInitLoaded);

  if (!permissionsInitLoaded) {
    return null;
  }
  return (
    <div style={{ display: 'flex', height: '100%', background: '#fff' }}>
      <Result
        style={{ margin: 'auto' }}
        status="403"
        title="403"
        subTitle={t(
          'NoPermissionsCard.NoPermissions',
          "You don't have permissions to view this page.",
        )}
      />
    </div>
  );
};

export default NoPermissionsCard;
